import { registerAction } from '../../Action'
import {
  deserializeJson,
  deserializeUpdatedJson,
} from '../../jsonApiDeserializer'

const LOAD_JSON_API_ENTITIES = 'LOAD_JSON_API_ENTITIES'

const reducer = (state = {}, action) => ({
  ...deserializeJson({ payload: action.payload, state }),
})

const LOAD_UPDATED_JSON_API_ENTITIES = 'LOAD_UPDATED_JSON_API_ENTITIES'

const updated_reducer = (state = {}, action) => ({
  ...deserializeUpdatedJson({ payload: action.payload, state }),
})

export const loadJsonApiEntities = registerAction(LOAD_JSON_API_ENTITIES, {
  reducer,
})
export const loadUpdatedJsonApiEntities = registerAction(
  LOAD_UPDATED_JSON_API_ENTITIES,
  { reducer: updated_reducer }
)
